import { defineMessages } from '@jutro/locale';

export default defineMessages({
    unableToCompleteQuoteTitle: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.We\'re unable to complete your quote',
        defaultMessage: 'We\'re unable to complete your quote'
    },
    unableToCompleteQuoteOnlineTitle: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.We\'re unable to complete your quote online',
        defaultMessage: 'We\'re unable to complete your quote online'
    },
    reasons: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.Reasons:',
        defaultMessage: 'Reasons:'
    },
    returnToQuote: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.Return to Quote',
        defaultMessage: 'Return to Quote'
    },
    returnToAccountPage: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.Return to Account page',
        defaultMessage: 'Return to Account page'
    },
    IAPCSDefault: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_DEFAULT',
        defaultMessage: 'We\'re sorry, due to technical difficulties we are unable to process your quote online at this time. Please watch the dashboard for more information and try again later.'
    },
    EAPCSDefaultContactUs: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.EA_PCS_DEFAULT_CONTACT_US',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-866-539-1315</strong>. '
    },
    IAPCSDefaultContactUs: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_DEFAULT_CONTACT_US',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-800-255-0332</strong>. '
    },
    IAPCSDefaultContactUs2: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_DEFAULT_CONTACT_US2',
        defaultMessage: 'Please include your error code <strong>{errorCode}</strong>.'
    },
    IAPCSDefaultQuoteContactUs: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_DEFAULT_QUOTE_CONTACT_US',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-800-255-0332</strong>.  '
    },
    EAPCSDefaultQuoteContactUs: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_DEFAULT_QUOTE_CONTACT_US',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-866-539-1315</strong>.  '
    },
    IAPCSDefaultQuoteContactUs2: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_DEFAULT_QUOTE_CONTACT_US2',
        defaultMessage: 'Please include your quote number <strong>{quoteNumber}</strong> and error code <strong>{errorCode}</strong>.'
    },
    EAPCSDefaultQuoteContactUsWithoutErrorCode: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_DEFAULT_QUOTE_CONTACT_US_WITHOUT_ERROR_CODE',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-866-539-1315</strong>.  '
    },
    IAPCSDefaultQuoteContactUsWithoutErrorCode: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_DEFAULT_QUOTE_CONTACT_US_WITHOUT_ERROR_CODE',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-800-255-0332</strong>.  '
    },
    IAPCSDefaultQuoteContactUsWithoutErrorCode2: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_DEFAULT_QUOTE_CONTACT_US_WITHOUT_ERROR_CODE2',
        defaultMessage: 'Please include your quote number <strong>{quoteNumber}</strong>.'
    },
    IAPCSFixable: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_FIXABLE',
        defaultMessage: 'Due to the reason(s) listed below, we are unable to proceed with your quote. Click the Return to Quote page link to resolve the item(s) listed.'
    },
    EAPCSFixableContactUs: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_FIXABLE_CONTACT_US',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-866-539-1315</strong>.'
    },
    IAPCSFixableContactUs: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_FIXABLE_CONTACT_US',
        defaultMessage: 'You can contact us by chat or call customer service at <strong>1-800-255-0332</strong>.'
    },
    IAPCSFixableContactUs2: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_FIXABLE_CONTACT_US',
        defaultMessage: 'Please include your quote number <strong>{quoteNumber}</strong> and error code <strong>{errorCode}</strong>.'
    },
    EAPCSNonFixable: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_NON_FIXABLE',
        defaultMessage: 'We are unable to process your quote online at this time.  For assistance, contact us by chat or call customer service at <strong>1-866-539-1315</strong>.'
    },
    IAPCSNonFixable: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_NON_FIXABLE',
        defaultMessage: 'We are unable to process your quote online at this time.  For assistance, contact us by chat or call customer service at <strong>1-800-255-0332</strong>.'
    },
    IAPCSNonFixableContactUs: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.IA_PCS_NON_FIXABLE_CONTACT_US',
        defaultMessage: 'Please include your quote number <strong>{quoteNumber}</strong>, error code <strong>{errorCode}</strong> and the reason(s) listed below.'
    },
    GCSDefault: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.GCS_DEFAULT',
        defaultMessage: 'We\'re sorry, due to technical difficulties we are unable to process your quote online at this time.'
    },
    GCSDefaultContactUs: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.GCS_DEFAULT_CONTACT_US',
        defaultMessage: 'Contact your support team for assistance and include your quote number <strong>{quoteNumber}</strong> and error code <strong>{errorCode}</strong> and the reason(s) listed below.'
    },
    contactSupportTeamNoData: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.Contact your support team for assistance.',
        defaultMessage: 'Contact your support team for assistance.'
    },
    GCSDefaultContactUsWithoutErrorCode: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.GCS_DEFAULT_CONTACT_US_WITHOUT_ERROR_CODE',
        defaultMessage: 'Contact your support team for assistance and include your quote number <strong>{quoteNumber}</strong> and the reason(s) listed below.'
    },
    GCSFixable: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.GCS_FIXABLE',
        defaultMessage: 'Due to the reason(s) listed below, we are unable to proceed with your quote. Click the Return to Quote page link to resolve the item(s) listed.'
    },
    GCSNonFixable: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.GCS_NON_FIXABLE',
        defaultMessage: 'We are unable to process your quote online at this time.  '
    },
    GCSNonFixable2: {
        id: 'ml.agent.quoteandbind.common.controllers.ContactUsCtrl.GCS_NON_FIXABLE2',
        defaultMessage: 'Contact your support team for assistance and include your quote number <strong>{quoteNumber}</strong> and error code <strong>{errorCode}</strong> and the reason(s) listed below.'
    },
});
